import {
	LOGIN_SUCCESS,
	LOGOUT,
	USER_LOADING,
} from "../actions/type"
export default function user(state = {
	isLoggedIn: false,
	userInfo: localStorage.getItem("iHealthlabs-sdk-user") ? JSON.parse(localStorage.getItem("iHealthlabs-sdk-user")) : {},
	userList: [],
	loading: false,
}, action) {
  const { type, payload } = action;
	switch(type){
    case LOGIN_SUCCESS: {
			const { token } = payload;
			token && localStorage.setItem("iHealthlabs-sdk-token", JSON.stringify(payload));
      return {
				...state,
				isLoggedIn: true,
				userInfo: payload,
      }
		}
		case LOGOUT: {
			localStorage.setItem("iHealthlabs-sdk-token", null)
			return {
				...state,
				isLoggedIn: false,
				userInfo: {}
			}
		}
		case USER_LOADING: {
			return {
				...state,
				loading: payload,
			}
		}
    default:
      return state;
	}
}